import { CheckoutTermAcceptService } from './../../services/checkout-term-accept/checkout-term-accept.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, ViewEncapsulation, Inject, ElementRef } from "@angular/core";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { tap } from 'rxjs/operators';

@Component({
  selector: "checkout-term-accept-aside-panel",
  templateUrl: "./checkout-term-accept-aside-panel.component.html",
  styleUrls: ["checkout-term-accept-aside-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CheckoutTermAcceptSidePanelComponent extends DialogPanelComponentContent {
  public termsForm: FormGroup;
  public agreementTermContent: string;
  private agreementTermContractGuid: string;
  private isContractAccepted: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public elementRef: ElementRef,
    public checkoutTermAcceptService: CheckoutTermAcceptService,
    private dialogReference: MatDialogRef<CheckoutTermAcceptSidePanelComponent>,
    private formBuilder: FormBuilder,
  ) {
    super(elementRef, true);

    this.termsForm = this.formBuilder.group({
      agree: ['', Validators.required],
    });

    this.checkoutTermAcceptService.getAgreementTerm(
      this.data.ticker
    ).pipe(
      tap(
        (agreementTerm) => {
          this.agreementTermContent = agreementTerm.value.content;
          this.agreementTermContractGuid = agreementTerm.value.contractGuid;
        }
      )
    ).subscribe();
  }

  public redirectExternal(url: string) {
    window.location.href = `${url}`;
  }

  public acceptTerm() {
    this.checkoutTermAcceptService.acceptTerm({
      contractGuid: this.agreementTermContractGuid,
      status: true,
    }).then((_) => {
      this.isContractAccepted = true;
      this.close(this.dialogReference, this.isContractAccepted);
    })
  }

  public redirectStocks() {
    this.close(this.dialogReference, null);
  }
}
